/**
 * Per-user community settings (community_user_settings_beta).
 * Maps user_id -> read_distance_m (nearby read radius, 1000-10000m).
 */
export const SEED_USER_SETTINGS = {
  1001: 3000,
  1002: 5000,
  1004: 1000,
};

export const DEFAULT_READ_DISTANCE_M = 1000;
